import { StudyDto } from './../../_models/studyBrowser.models';
import { DownloadFactoryStudySummaryReportParams } from './../../_models/app.models';
import {APP_CONFIGS, COMMON_ACTION_TYPES, STUDY_BROWSER_ACTIONS } from "../../_constants";
import {studyBrowserService} from "../../_services";
import {exceptionHandler} from "../../_helpers";
import { AddStudyOperationCommentPayloadDto, DownloadSbuStudySummaryReportParams, StudyBrowserListFiltersParamsDto } from '../../_models';

const getStudyBrowserList = (filters: StudyBrowserListFiltersParamsDto, onSuccess, onError) => {
    return action => {
        action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.REQUEST})
        studyBrowserService.getStudyBrowserList(filters)
            .then( (res) => {
                const _data = res.data
                _data.forEach(s => {
                    if(s.videoUrl){
                        s.videoUrl = `${APP_CONFIGS.API_BASE}/api/v1/videos/getvideostream?id=${s.videoUrl}&Subscription-Key=${APP_CONFIGS.APIM_SUBSCRIPTION_KEY}`
                    }
                });
                _data.sort(function(a: any,b: any){
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    // @ts-ignore
                    return new Date(b.createdAt) - new Date(a.createdAt);
                  });
                action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const onChangeStudyListIsBestVideo = (studyId: string) => {
    return(action, getState) => {
        const studyList: StudyDto[] = getState().studyBrowser.studyBrowserList.data;
        let updatedStudyList: StudyDto[] = []
        for(const i of studyList) {
            updatedStudyList.push({
                ...i,
                isBestVideo: `${i.studyId}` === `${studyId}`
            })
        }
        action({type: STUDY_BROWSER_ACTIONS.UPDATE_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.SUCCESS, data: updatedStudyList})
    }
}

const clearStudyBrowserList = () => {
    return action => {
        action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_LIST + COMMON_ACTION_TYPES.CLEAR})
    }
}

const getStudyBrowserDetail = (studyBrowserId: number, onSuccess, onError) => {
    return action => {
        action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.REQUEST})
        studyBrowserService.getStudyBrowserDetail(studyBrowserId)
            .then( (res) => {
                action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data)
            })
            .catch( (error) => {
                action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getStudyDependentDetail = (studyBrowserId: number, onSuccess, onError) => {
    return action => {
        action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.REQUEST})
        studyBrowserService.getStudyDependentDetail(studyBrowserId)
            .then( (res) => {
                action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data)
            })
            .catch( (error) => {
                action({type: STUDY_BROWSER_ACTIONS.GET_STUDY_BROWSER_DETAIL + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const downloadStudyReport = (studyId: number, onSuccess?, onError?) => {
    return action => {
        studyBrowserService.downloadStudyReport(studyId)
    }
}

const downloadSbuStudySummaryReport = (params: DownloadSbuStudySummaryReportParams, onSuccess?, onError?) => {
    return action => {
        studyBrowserService.downloadSbuStudySummaryReport(params)
    }
}

const downloadFactoryStudySummaryReport = (params: DownloadFactoryStudySummaryReportParams, onSuccess?, onError?) => {
    return action => {
        studyBrowserService.downloadFactoryStudySummaryReport(params)
    }
}

const addStudyOperationComment = (data: AddStudyOperationCommentPayloadDto, onSuccess?:() => void, onError?: (error: string) => void) => {
    return action => {
        action({type: STUDY_BROWSER_ACTIONS.ADD_STUDY_OPERATION_COMMENT + COMMON_ACTION_TYPES.REQUEST})
        studyBrowserService.addStudyOperationComment(data)
        .then(() => {
            action({type: STUDY_BROWSER_ACTIONS.ADD_STUDY_OPERATION_COMMENT + COMMON_ACTION_TYPES.SUCCESS})
            onSuccess && onSuccess()
        })
        .catch((error) => {
            action({type: STUDY_BROWSER_ACTIONS.ADD_STUDY_OPERATION_COMMENT + COMMON_ACTION_TYPES.ERROR})
            onError && onError(exceptionHandler.catchError(error.response))
        })
    }
}

export const studyBrowserActions =  {
    getStudyBrowserList,
    getStudyBrowserDetail,
    clearStudyBrowserList,
    downloadStudyReport,
    downloadSbuStudySummaryReport,
    getStudyDependentDetail,
    addStudyOperationComment,
    downloadFactoryStudySummaryReport,
    onChangeStudyListIsBestVideo
}
